export default __webpack_public_path__ + "static/media/minus-danger-rounded.5139d5b2.svg";